import React,{useState} from "react";
import styled from "../tenders/style.module.css";
import { useStatStyles } from "@chakra-ui/react";
import goldImg from '../../assets/images/gold_icon.png'
import silverImg from '../../assets/images/silver_icon.png'
import bronzeImg from '../../assets/images/bronze_icon.png'

const MedalTally = () => {

    return (
        <>
            <div className={` ${styled.medal} `} style={{  width: "100%" }}>
                <div style={{ background: "#08549c", borderRadius: "5px", paddingTop: "20px" }}>
                    <h4
                        style={{
                            color: "white",
                            fontWeight: "800",
                            fontSize: "18px",
                            // marginTop: "40px",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        38 वें नेशनल गेम्स 2025 में बिहार के खिलाड़ियों का प्रदर्शन
                    </h4>
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr className={`table-primary`}>

                                <th className={`${styled.medalth}`}>
                                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                                        <h5 style={{ fontWeight: "800", fontSize: "100%" }}>स्वर्ण पदक</h5>
                                        <img src={goldImg} style={{ width: '20%', marginLeft: ".6rem" }} />
                                    </div>
                                </th>

                                <th className={`${styled.medalth}`}>
                                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                                        <h5 style={{ fontWeight: "800", fontSize: "100%" }}>रजत पदक</h5>
                                        <img src={silverImg} style={{ width: '20%', marginLeft: ".6rem" }} />
                                    </div>
                                </th>

                                <th className={`${styled.medalth}`}>
                                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                                        <h5 style={{ fontWeight: "800", fontSize: "100%" }}>कांस्य पदक</h5>
                                        <img src={bronzeImg} style={{ width: '20%', marginLeft: ".6rem" }} />
                                    </div>
                                </th>

                                <th className={`${styled.issue}`}>
                                    {/* <h5 style={{topPadding:"10px"}}>कुलपदक</h5> */}
                                    <div className={`${styled.texttt}`}>
                                        <h5 style={{ fontWeight: "800", fontSize: "100%" }}>कुल पदक</h5>
                                        {/* <img src={goldImg} style={{ width: '20%', marginLeft: ".6rem" }} /> */}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={`${styled.medaltd}`}>01 </td>
                                <td className={`${styled.medaltd}`}>06</td>
                                <td className={`${styled.medaltd}`}>05</td>
                                <td className={`${styled.medaltd}`}>12</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
export default MedalTally

